import napStyles from './nap.json'
import mediaQuery from './mediaQuery'
import * as theme from './nap/index'
import motionSpecs from './motionSpecs'
import typestack from './typestack'

export default {
  direction: 'ltr',
  typography: napStyles,
  baseOverrides: theme.baseOverrides,
  breakpoints: theme.breakpoints,
  spacingMultiplier: 8,
  rowOffsetTopSmall: 3,
  rowOffsetTopMedium: 4,
  rowOffsetTopLarge: 6,
  rowOffsetTopXLarge: 6,
  fullBleed: true,
  mediaQuery,
  motionSpecs,
  typestack: typestack['nap-en'],
  custom: theme
}
